import { z } from 'zod';
const NewsletterValidationSchema = z.object({
    Email: z.string().email()
});
export { NewsletterValidationSchema };
//# sourceMappingURL=services.js.map